import dayjs from 'dayjs'
import customParseFormat from 'dayjs/plugin/customParseFormat'
import timezone from 'dayjs/plugin/timezone'
import utc from 'dayjs/plugin/utc'

dayjs.extend(customParseFormat)
dayjs.extend(utc)
dayjs.extend(timezone)

export function formatTimeAndTimezone(apptStr) {
  const sourceTz = 'America/Chicago'
  const inputFormat = 'M/D/YYYY h:mm:ss A'
  const locale = 'en-US'

  //   // Basic sanity checks
  if (typeof apptStr !== 'string' || apptStr.trim().length < 10) {
    return apptStr
  }

  const trimmed = apptStr.trim()

  // Strict parse in the *source timezone*
  // Note: dayjs.tz(string, format, tz) uses the provided format + timezone.
  const parsedInSource = dayjs.tz(trimmed, inputFormat, sourceTz)

  // Validate
  if (!parsedInSource.isValid()) {
    return apptStr
  }

  // Convert to user's timezone
  const userTz = dayjs.tz.guess()
  const userTime = parsedInSource.tz(userTz)

  // Format time
  const timeText = userTime.format('h:mma') // "2:00pm"

  // Friendly tz abbreviation (EST/EDT/etc.) via Intl
  const tzShort = new Intl.DateTimeFormat(locale, {
    timeZone: userTz,
    timeZoneName: 'short',
  })
    .formatToParts(userTime.toDate())
    .find((p) => p.type === 'timeZoneName')?.value

  return `${timeText} ${tzShort}`
}
